// src/components/geral/PageContent.js
import React from 'react';
import './PageContent.css';

const PageContent = ({children, maxAltura, containerRef, onContainerScroll}) => {


  return (
    <div
      ref={containerRef}
      className="page-content-table-container"
      style={maxAltura ? {maxHeight:maxAltura} : undefined}
      onScroll={onContainerScroll}
    >
      {children}
    </div>
  );
};

export default PageContent;
